import { useAction, useAtom } from '@reatom/npm-react'
import styled from 'styled-components'

import { Array, AsyncStateN } from '@blade/std-lib'
import { useHapticFeedback } from '@blade/ui-kit'
import {
  openExtendPremiumFlowEvent,
  openPremiumCurrencyDetailsEvent,
} from '@root/entities/premium'
import {
  ActivePremiumCard,
  ActivePremiumCardSkeleton,
} from '@root/entities/premium/ui'
import { FadeOverflow, InfoMessage } from '@root/shared/ui-kit'

import { userPremiumActiveStateAtom } from '../../user-premium'

import { ProfilePremiumListEmpty } from './profile-premium-list-empty'

import type { CurrencyWithPremium } from '@root/entities/currency'
import type { ClassNameProps } from '@root/shared/react'

const placeholders = Array.range(1, 3)

type ProfilePremiumListProps = {} & ClassNameProps

export const ProfilePremiumList: React.FC<ProfilePremiumListProps> = ({
  className,
}) => {
  const [activePremiumsState] = useAtom(userPremiumActiveStateAtom)
  const openPremiumCurrencyDetails = useAction(openPremiumCurrencyDetailsEvent)
  const openExtendPremiumDrawer = useAction(openExtendPremiumFlowEvent)

  const handleCurrency = (
    currency: CurrencyWithPremium.CurrencyWithPremium,
  ) => {
    openPremiumCurrencyDetails({ currencyAddress: currency.currency.address })
  }
  const haptics = useHapticFeedback()

  const handleActiveClick = () => {
    haptics.impactOccurred('light')
    // TODO: open active drawer
  }

  return AsyncStateN.matchWaiting(activePremiumsState, {
    Waiting: () => (
      <Root className={className}>
        <Main mode="always" variant="vertical">
          {placeholders.map((it) => (
            <ActivePremiumCardSkeleton key={it} />
          ))}
        </Main>
      </Root>
    ),
    Error: () => (
      <InfoContainer>
        <InfoMain>
          <InfoMessage intent="error" variant="dt" />
        </InfoMain>
      </InfoContainer>
    ),
    Success: (activePremiums) => {
      if (activePremiums.length === 0) {
        return <ProfilePremiumListEmpty />
      }

      return (
        <Root className={className}>
          <Main mode="always" variant="vertical">
            {activePremiums.map((meta) => (
              <ActivePremiumCard
                key={meta.currencyAddress}
                currency={meta.currency}
                onEdit={handleCurrency}
                onExtend={openExtendPremiumDrawer}
                premium={meta}
                onActiveClick={handleActiveClick}
              />
            ))}
          </Main>
          {/* Double check buy button is needed here */}
          {/* <Footer>
            <ButtonPurchase
              fullWidth
              product="premium"
              type="button"
              radius="rounded"
              onClick={handleClick}
            >
              {t('profile.buy_d_premium')}
            </ButtonPurchase>
          </Footer> */}
        </Root>
      )
    },
  })
}

const Root = styled.div`
  display: grid;
  align-content: start;
  height: 100%;
  /* grid-template-rows: 1fr auto; */
`

const Main = styled(FadeOverflow)`
  display: grid;
  height: 100%;
  overflow-y: auto;
  padding-inline: 12px;
  padding-block: 12px 6px;
  gap: 6px;
  grid-auto-rows: max-content;
`

const InfoContainer = styled.div`
  display: grid;
  height: 100%;
  gap: 6px;
  grid-template-rows: 1fr auto;
`

const InfoMain = styled(FadeOverflow)`
  display: grid;
  height: 100%;
  gap: 6px;
  padding-inline: 12px;
  padding-block: 12px 6px;
`
